export interface DeletingTestingFile {
    id: number;
    result_id: number;
    status: number;
    note: string;
    audit_note: string;
    created_by: number;
    created_by_name?: string;
    submitted_at: string;
    audited_by: number;
    audited_by_name?: string;
    audited_at: string;
    product: string;
    order: string;
    testing_station: string;
    is_mine?: boolean
}

export interface DeletingTestingFileItem {
    file_id: number;
    deleting_id: number;
    created_at: string;
    file_path: string;
    serial_number: string;
}


export const DELETING_FILE_STATUS_NEW = 1
export const DELETING_FILE_STATUS_SUBMIT = 2
export const DELETING_FILE_STATUS_APPROVE = 3
export const DELETING_FILE_STATUS_DISAPPROVE = 4

export const DeletingTestingFileStatusNames = ['', 'New', 'Submitted', 'Approved', 'Disapproved']